import React from 'react';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

const OurServices = () => (
  <div>
    <ul className="nav-list">
      <div className="green-menu">
        Nossos Serviços
      </div>
      <li className="ourServices">
        <ArrowForwardIosIcon className="next-icon-os" fontSize="small" />
        <a href="https://www.alobebe.com.br/lojas-de-bebe">Nossa Lojas</a>
      </li>
      <li className="ourServices">
        <ArrowForwardIosIcon className="next-icon-os" fontSize="small" />
        <a href="https://www.alobebe.com.br/painel/pedidos">Meus Pedidos</a>
      </li>
      <li className="ourServices">
        <ArrowForwardIosIcon className="next-icon-os" fontSize="small" />
        <a href="https://www.alobebe.com.br/cha-de-bebe">Lista de Chá de Bebê</a>
      </li>
      <li className="ourServices">
        <ArrowForwardIosIcon className="next-icon-os" fontSize="small" />
        <a href="https://www.alobebe.com.br/cartao-presente">Cartão Presente</a>
      </li>
      <li className="ourServices">
        <ArrowForwardIosIcon className="next-icon-os" fontSize="small" />
        <a href="https://www.alobebe.com.br/lista-de-desejos">Lista de Desejos</a>
      </li>
      <li className="ourServices">
        <ArrowForwardIosIcon className="next-icon-os" fontSize="small" />
        <a href="https://www.alobebe.com.br/programa-fidelidade-abbclub">Programa de Fidelidade</a>
      </li>
      <li className="ourServices">
        <ArrowForwardIosIcon className="next-icon-os" fontSize="small" />
        <a href="https://www.alobebe.com.br/fale-conosco">Fale Conosco</a>
      </li>
    </ul>

  </div>
);

export default OurServices;
